module.exports = __webpack_public_path__ + "img/table1.214c3776.png";